import { render, staticRenderFns } from "./sync_current_gear.vue?vue&type=template&id=ac1d5bd0"
import script from "./sync_current_gear.vue?vue&type=script&lang=ts"
export * from "./sync_current_gear.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports